export function replaceRenderFunction(
// biome-ignore lint/suspicious/noExplicitAny: needed for type inference
renderFn, 
// biome-ignore lint/suspicious/noExplicitAny: needed for type inference
callback) {
    if (typeof renderFn !== 'function') {
        return renderFn;
    }
    // We'll start by returning a new render fn so that we can hijack its contents
    // biome-ignore lint/suspicious/noExplicitAny: needed for type inference
    return (...args) => {
        // Then call the old function and check its return type
        const innerRenderFn = renderFn(...args);
        if (typeof innerRenderFn === 'function') {
            // When the user returns a new function, the component will call that function with it's own DOM element.
            // In this case, we'll assume that the returned function will be a React component. It's no use calling a React
            // function with a DOM element, so we'll once again hijack this, and return a new function that does accept
            // the DOM element. This function will then take that DOM element and render the React component manually.
            return (el, idx) => {
                if (el && el instanceof HTMLElement) {
                    // We'll render our new portal component inside of `<slot/>`. This is the only place
                    // in a Stencil component where we can render React components.
                    // biome-ignore lint/suspicious/noExplicitAny: needed for type inference
                    callback(innerRenderFn, el, args, idx);
                }
            };
        }
        // Return whatever the render function returned, probably a string or a Stencil VNode
        return innerRenderFn;
    };
}
